import { Typography } from "@mui/material";
import { useSnackbar } from "notistack";
import { useCallback, useState } from "react";

export const useApi = <OutPut, Input = undefined>(
  api: (param?: Input) => Promise<OutPut | string | undefined>,
) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<OutPut>();

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const callApi = useCallback(
    async (param?: Input): Promise<OutPut | undefined> => {
      setLoading(true);
      const response = await api(param);
      setLoading(false);
      if (response && typeof response === "string") {
        enqueueSnackbar(<Typography variant="caption">{response}</Typography>, {
          variant: "error",
          SnackbarProps: { onClick: () => closeSnackbar() },
        });
        return undefined;
      } else {
        setData(response as OutPut);
        return response as OutPut;
      }
    },
    [api, closeSnackbar, enqueueSnackbar],
  );

  return {
    api: callApi,
    loading,
    data,
  };
};
